import inputData from './inputData/customer-effort-score-survey';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'customer-effort-score-survey',
  title: 'Customer Effort Score (CES) Survey',
  description: 'Measure how easy it is for customers to interact with your product, and use those insights to reduce churn and strengthen loyalty.',
  image: '/images/templates/customer-effort-score-survey.png',
  tags: ['get-feedback', 'customer-success', 'product'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

